import { isEmail as validateIsEmail } from '@/utils/libs/validator/format';
/**
 * Eメールアドレスのドメイン
 */
export const ForbiddenEmailDomains = [
    'hotmail.co.jp',
    'hotmail.com',
    'gmail.com',
    'infoseek.jp',
    'yahoo.com',
    'yahoo.co.jp',
    'livedoor.com',
    'mail.goo.ne.jp',
    'nifmail.jp',
    'excite.co.jp',
    'i.softbank.jp',
    'ezweb.ne.jp',
    'docomo.ne.jp',
    'icloud.com',
    'outlook.jp',
];
/**
 * Eメールアドレスのドメイン(正規表現)
 */
export const ForbiddenEmailDomainRegExps = ForbiddenEmailDomains.map((domain) => new RegExp(`${domain}$`));
/**
 * Eメールアドレスチェック
 * @param text エラー文言
 * @returns {function(*=): string}
 */
export const isEmail = (text) => (value) => {
    if (!value) {
        return undefined;
    }
    return validateIsEmail(value) ? undefined : text;
};
/**
 * Eメールアドレスのドメインチェック
 * @param text エラー文言
 * @returns {function(*): string}
 */
export const isAllowedEmailDomain = (text) => (value) => value && !ForbiddenEmailDomainRegExps.find((re) => value.match(re))
    ? undefined
    : text;
/**
 * Eメールアドレスのドメインチェック（含まない）
 * @param domains 対象のドメインの配列
 * @param text エラー文言
 * @returns {function(*): string|*}
 */
export const isIncludedEmailDomain = (domains, text) => (value) => {
    if (!value) {
        return text;
    }
    const domain = value.split('@')[1];
    return !domains.includes(domain) ? undefined : text;
};
/**
 * Eメールアドレスのドメインチェック（含む）
 * @param domains 対象のドメインの配列
 * @param text エラー文言
 * @returns {function(*): string|*}
 */
export const isNotIncludedEmailDomain = (domains, text) => (value) => {
    if (!value) {
        return text;
    }
    const domain = value.split('@')[1];
    return domains.includes(domain) ? undefined : text;
};
